import styled from "@emotion/styled";
import {
  Avatar,
  Box,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import MediaAssets from "assets";
import {
  ButtonComponent,
  FormFieldContainer,
  MediaUploadComponent,
  SwitchComponent,
  TextFieldComponent,
} from "components/ui-elements";
import { FieldArray, getIn, useFormikContext } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import styles from "./Opportunity.module.css";
import QuillEditor from "components/quill-editor/QuillEditor";
import { IInitinalValueProjectContent } from "../InitinalValuesProjectContent";
import CurrentInfraStroyMedia from "../opportunity-doc/CurrentInfraStroyMedia";
import { useSelector } from "react-redux";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

const FormFieldContainerWrapper = styled(FormFieldContainer)`
  padding: 2rem;
  margin: 2rem;
`;

function CurrentInfraStory() {
  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue,
    setFieldError,
    handleBlur,
    touched,
    errors,
  } = useFormikContext<IInitinalValueProjectContent>();

  const [currentlyOpenedIndex, setCurrentlyOpenedIndex] = useState(999);
  const isViewMode = useSelector((state: any) => (
    state?.projectContentManagement?.isViewMode
 ));

  const handleCurrentInfraStoryMedia = (imageIndex: number) => {
    setCurrentlyOpenedIndex(imageIndex);
  };

  const handleTextEditor = (
    name: string,
    newValue: string,
    options: any,
    { setFieldValue, setFieldError }: any
  ) => {
    // if (options?.isError) {
    //   setFieldError(name, "Maximum character exceed");
    // } else {
      setFieldValue(name, newValue);
    // }
  };

  return (
    <div>
      <Stack justifyContent={"flex-start"} padding={2} spacing={1}>
        <Typography>Current Infra Story</Typography>

        <FormControlLabel
          className="switch-form-label"
          name={"opportunityDoc.isCurrentInfraStoryActive"}
          checked={values?.opportunityDoc?.isCurrentInfraStoryActive}
          onChange={handleChange}
          control={<SwitchComponent />}
          label=""
          labelPlacement="start"
          disabled={isViewMode}
        />
        <IconButton>
          <Tooltip title={"Current Infra Story"} placement="top">
            <Avatar
              className={styles["Avator"]}
              src={MediaAssets.ic_info}
              variant="rounded"
            />
          </Tooltip>
        </IconButton>
      </Stack>
      <Grid item xs={3} sm={3} md={3} lg={3} xl={3} p={3}>
        <TextFieldComponent
          required
          type="text"
          placeholder="Enter"
          label="Section Heading"
          name={`opportunityDoc.currentInfraStory.heading`}
          value={values?.opportunityDoc?.currentInfraStory?.heading}
          onChange={handleChange}
          onBlur={handleBlur}
          inputProps={{ maxLength: 40 }}
          fieldhelpertext={
            getIn(touched, "opportunityDoc.currentInfraStory.heading") &&
            getIn(errors, "opportunityDoc.currentInfraStory.heading")
          }
          error={Boolean(
            getIn(errors, "opportunityDoc.currentInfraStory.heading") &&
              getIn(touched, "opportunityDoc.currentInfraStory.heading")
          )}
          disabled={isViewMode}
        />
      </Grid>
      <FieldArray
        name="opportunityDoc.currentInfraStory.stories"
        render={(arrayHelpers) => (
          <div>
      {values?.opportunityDoc?.currentInfraStory?.stories.length > 0 &&
        values?.opportunityDoc?.currentInfraStory?.stories.map(
          (element: any, index: number) => {
            return (
              <Fragment>
                <FormFieldContainerWrapper>
                  <Stack justifyContent={"flex-end"}>
                    {values?.opportunityDoc?.currentInfraStory?.stories
                      ?.length > 3 && (
                      <IconButton
                        disabled={isViewMode}
                        aria-label="delete"
                        data-testid="button-delete"
                        onClick={() => {
                          arrayHelpers.remove(index);
                        }}
                      >
                        <DeleteOutlineOutlinedIcon className="table-action-icon delete-icon" />
                      </IconButton>
                    )}
                  </Stack>
                  <Grid
                    container
                    alignItems={"center"}
                    justifyContent={"space-between"}
                  >
                    <Grid item xs={7} sm={7} md={7} lg={7} xl={8}>
                      <Box mr={"20rem"}>
                        <TextFieldComponent
                          required
                          type="text"
                          placeholder="Enter"
                          label="Image Title"
                          name={`opportunityDoc.currentInfraStory.stories.${index}.title`}
                          value={
                            values?.opportunityDoc?.currentInfraStory?.stories[
                              index
                            ]?.title
                          }
                          onChange={handleChange}
                          inputProps={{ maxLength: 30 }}
                          onBlur={handleBlur}
                          fieldhelpertext={
                            getIn(
                              touched,
                              `opportunityDoc.currentInfraStory.stories.${index}.title`
                            ) &&
                            getIn(
                              errors,
                              `opportunityDoc.currentInfraStory.stories.${index}.title`
                            )
                          }
                          error={Boolean(
                            getIn(
                              errors,
                              `opportunityDoc.currentInfraStory.stories.${index}.title`
                            ) &&
                              getIn(
                                touched,
                                `opportunityDoc.currentInfraStory.stories.${index}.title`
                              )
                          )}
                          disabled={isViewMode}
                        />
                      </Box>
                      <Typography>Description *</Typography>
                      <QuillEditor
                        placeholder="Enter description"
                        className={styles["QuillEditor"]}
                        name={`opportunityDoc.currentInfraStory.stories.${index}.description`}
                        value={
                          values?.opportunityDoc?.currentInfraStory?.stories[
                            index
                          ]?.description
                        }
                        onChange={(
                          name: string,
                          newValue: string,
                          options: any
                        ) =>
                          handleTextEditor(name, newValue, options, {
                            setFieldValue,
                            setFieldError,
                          })
                        }
                        // style={{ height: "12rem" }}s
                        inputProps={{ maxLength: 240 }}
                        onBlur={handleBlur}
                        style={
                           { height: "126px" }
                        }
                        disabled={isViewMode}
                      />
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={4} xl={3}>
                      <CurrentInfraStroyMedia
                        index={index}
                        currentlyOpenedIndex={currentlyOpenedIndex}
                        handleCurrentInfraStoryMedia={
                          handleCurrentInfraStoryMedia
                        }
                      />
                    </Grid>
                  </Grid>
                </FormFieldContainerWrapper>

                <Grid item xs={3} sm={3} md={3} lg={3} xl={3} ml={2}>
                  {values?.opportunityDoc?.currentInfraStory?.stories?.length -
                    1 ===
                    index &&
                    values?.opportunityDoc?.currentInfraStory?.stories?.length <
                      5 && (
                      <ButtonComponent
                        sx={{
                          textDecoration: "underline",
                          marginTop: "0.5rem",
                        }}
                        variant="text"
                        color="inherit"
                        onClick={() => {
                          arrayHelpers.push({
                            title: "",
                            description: "",
                            media: {
                              name: "",
                              key: "",
                              value: {
                                url: "",
                                size: 0,
                                width: 1024,
                                height: 1024,
                                mediaType: "image",
                              },
                            },
                          });
                        }}
                        disabled={isViewMode}
                      >
                        + Add more Values
                      </ButtonComponent>
                    )}
                </Grid>
              </Fragment>
            );
          }
        )}
        </div>
        )} />
      <Divider sx={{ mt: "0.5rem" }} />
    </div>
  );
}

export default CurrentInfraStory;
